module.exports = __webpack_public_path__ + "media/tubulovillous adenoma.c9b7f4c9.wav";